import React from 'react';
import DateUtils from '../../../lib/DateUtils';
import Tooltip from '../../elements/mui/Tooltip';
import { ReactComponent as InfoIcon } from 'new/components/icons/info.svg';
import { useSelector } from 'react-redux';
const styles = {
  icon: {
    width: 11,
    height: 11,
    fill: 'var(--color-greyscale-600)',
  },
};

function StatsTooltipView() {
  const { start_time, end_time } = useSelector((state) => state.metrics.dashboard);

  const statsStartTime = DateUtils.convertDateStringToFormat(start_time, 'MMM D (h:mma z)');
  const statsEndTime = DateUtils.convertDateStringToFormat(end_time, 'MMM D (h:mma z)');

  const popupMessage = `These numbers are for ${statsStartTime} - ${statsEndTime}. Numbers are refreshed every hour.`;
  return (
    <Tooltip title={popupMessage} arrow={true}>
      <InfoIcon style={styles.icon} />
    </Tooltip>
  );
}

StatsTooltipView.defaultProps = {
  start_time: null,
  end_time: null,
};

export default StatsTooltipView;
